<div class="row mt-3" *ngIf="listaPendentes?.length > 0">
  <div class="col-md-12">
    <h5 class="text-secondary"><em class="far fa-clock"></em> Pendentes</h5>
    <div class="card mb-2" *ngFor="let proponente of listaPendentes">
      <div class="card-header bg-secondary text-white">
        <span class="w-100">{{proponente.favorecido.nome}}</span>
        <span>
          <a class="btn btn-outline-light text-nowrap" (click)="incluirContrato(proponente)">
            <em class="fa fa-plus"></em> Incluir Contrato
          </a>
        </span>
      </div>
      <div class="card-body p-0">
        <table class="table table-sm table-eddy mb-0">
          <thead>
            <tr>
              <th scope="col" style="width: 55%">Item</th>
              <th scope="col" style="width: 170px">Marca</th>
              <th scope="col" class="text-center">Qtd.</th>
              <th scope="col" class="text-center" style="width: 90px">Valor Unit.</th>
              <th scope="col" class="text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let proposta of proponente.propostas">
              <td>
                {{proposta.memorial?.ordem}} - {{funcaoService.abreviarStr(proposta.memorial?.descricao, 70, true)}}
              </td>
              <td>{{proposta.marca}}</td>
              <td class="text-right">{{+proposta.quantidade_final | number:'1.0-0'}}</td>
              <td class="text-right">{{+proposta.valor_final | number:'1.2-2'}}</td>
              <td class="text-right">{{+proposta.quantidade_final * +proposta.valor_final | number:'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer text-right font-weight-bold">
        Total: {{totalizarPendente(proponente) | number:'1.2-2'}}
      </div>
    </div>
  </div>
</div>
<hr />
<div class="row">
  <div class="col-md-12">
    <h5 class="text-primary"><em class="fa fa-suitcase"></em> Contratos / Registros de Preço</h5>
    <div class="card mb-2" *ngFor="let contrato of entidade?.contratos">
      <div [class]="'card-header text-white bg-' + (contrato.tipo === 'CONTRATO' ? 'primary' : 'info')">
        <span class="w-100">
          {{contrato.favorecido?.cpf_cnpj | CPF}} - {{contrato.favorecido?.nome}}
        </span>
        <span>
          #{{contrato.numero | LICITACAO}} <span *ngIf="contrato.aditivo > 0">{{contrato.aditivo}}</span>
        </span>
      </div>
      <div class="card-body p-0">
        <table class="table table-sm table-eddy mb-0">
          <thead>
            <tr>
              <th scope="col" style="width: 75%">Item</th>
              <th scope="col" class="text-center">Qtd.</th>
              <th scope="col" class="text-center">Valor Unit.</th>
              <th scope="col" class="text-center">Valor Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of contrato.itens">
              <td>
                {{funcaoService.abreviarStr(item?.descricao, 67, true)}} {{item.unidade}}
              </td>
              <td class="text-right">{{+item.quantidade | number:'1.0-0'}}</td>
              <td class="text-right">{{+item.valor_total / +item.quantidade | number:'1.2-2'}}</td>
              <td class="text-right">{{+item.valor_total | number:'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer text-right font-weight-bold">
        Total: {{contrato.valor_contrato | number:'1.2-2'}}
      </div>
    </div>
  </div>
</div>

<lib-contrato-licitacao-dlg [login]="login" [proponente]="pendenteAtual" (callback)="callbackContrato($event)">
</lib-contrato-licitacao-dlg>